module.exports = global["jQuery"] = require("-!C:\\_GIT\\Repos\\easy-buy-template\\node_modules\\expose-loader\\index.js?$!.\\jquery.js");


//////////////////
// WEBPACK FOOTER
// ../node_modules/jquery/dist/jquery.js-exposed
// module id = 0
// module chunks = 0